module.exports = __webpack_public_path__ + "static/media/tw.29cab0c0.svg";